import { queryOptions, useQuery } from '@tanstack/react-query';
import { fetchEmailBounces } from '@/api/(admin)/email-bounces';
import type { EmailBouncesQueryInput } from '../-types';
import { toEmailBouncesBody } from '../-utils/listParams';

/**
 * Shared by the route loader and the component's hook.
 *
 * Keyed on the *converted* body rather than the raw input, so the loader's
 * URL-shaped values and `useTable`'s state-shaped values land on one cache
 * entry — otherwise the prefetch warms a key nothing reads.
 */
export function emailBouncesQueryOptions(input: EmailBouncesQueryInput) {
  const body = toEmailBouncesBody(input);
  return queryOptions({
    queryKey: ['admin', 'email-bounces', 'list', body] as const,
    queryFn: () => fetchEmailBounces(body),
    staleTime: 60_000,
  });
}

export function useEmailBounces(input: EmailBouncesQueryInput) {
  const query = useQuery(emailBouncesQueryOptions(input));

  return {
    ...query,
    rows: query.data?.data ?? [],
    totalCount: query.data?.metadata.pagination.total ?? 0,
  };
}
